import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { IVigenciaDto, VigenciaDto } from '@/shared/model/vigencia.model';
import { IDatosGenerales } from './persona/datos-generales';
import { TipoSolucion } from './enumerations/tipo-solucion.model';
import { File, IFile } from './file.model';
import * as personaUtils from '@/shared/util/format-util';
import { IProgramaIntegrado } from '@/shared/model/snp/programa-integrado.model';
import { LieSnp } from '@/shared/model/snp/lie.model';
import { PronaceSnp } from '@/shared/model/snp/pronaces.model';
import { RegistroTemaSnp } from '@/shared/model/snp/temas.model';
import { IUsuarioRol } from '@/shared/model/usuarioRol';
import { OpcionTerminalSnp } from '@/shared/model/snp/opcion-terminal.model';
import { AreaConocimiento } from '@/shared/model/snp/campo-conocimiento.model';
import { GeneracionSnp } from './snp/generaciones.model';
import { ICronograma } from '@/shared/model/cronogramaActividades.model';
import { Beca } from '@/shared/model/seguimiento/beca.model';
import { IValoracionIndividual } from '@/shared/model/snp/valoracion-individual.model';
import { IHijos } from './datosHijos.model';
import { CuestionarioSnp } from './snp/cuestionario.model';
import { Programa } from './programa.model';
import { IMovimiento, Movimiento } from './movimiento.model';
import { Cotutor, ICotutor } from './cotutor.model';
import { Coordinador } from './seguimiento/coordinador.model';
import { Declaraciones, IDeclaraciones } from '@/shared/model/snp//declaraciones.model';
import { FirmaFormato1 } from '@/shared/model/snp//formalizacion-formato1.model';
import { TipoSolicitud } from '@conacyt/perfil-usuario-client';
import {
  ActividadRetribucion,
  BecarioActividadRetribucion as BecarioRetribucion,
  IndicadoresRetribucion,
  PoblacionRetribucion,
  ResultadosRetribucion,
  TestimonioRetribucion,
  VinculacionRetribucion,
} from './ars/ars.model';
import { RetribucionSocial } from './exbecarios/retribucion-social.model';

export interface Solicitante {
  cvu?: string;
  nombre?: string;
  apellidoPaterno?: string;
  apellidoMaterno?: string;
  curp?: string;
  genero?: string;
  correo?: string;
}

export interface IRevisorResumen {
  id?: string;
  evaluacionId?: string;
  cvu?: string;
  revisorId?: string;
  nombre?: string | null;
  estado?: EstadoRevision | null;
}

export class RevisorResumen implements IRevisorResumen {
  constructor(
    public id?: string,
    public evaluacionId?: string,
    public cvu?: string,
    public revisorId?: string,
    public nombre?: string | null,
    public estado?: EstadoRevision | null
  ) {}
}

export interface SolicitudRizoma {
  solucionSolicitud?: {
    tipoSolucion?: TipoSolucion;
    nombreConvocatoria?: string;
  };
  tipoSolicitud?: {
    id?: TipoSolicitud;
    nombre?: string;
  };
  areaConocimiento?: {
    area?: {
      clave?: number;
      nombre?: string;
    };
  };
  programa?: {
    participante?: {
      institucion?: {
        nombreInstitucion?: string;
      };
      programa?: {
        nombre?: string;
        clave?: string;
      };
    };
  };
  apoyo?: {
    tipoApoyo?: {
      nombre?: string;
    };
    institucion?: {
      nombre?: string;
    };
    programa?: string;
  };
}

export interface ISolicitud {
  id?: string;
  nombre?: string | null;
  nombreAyudante?: string | null;
  usuario?: string | null;
  solucionId?: string | null;
  estado?: EstadoSolicitud | null;
  revisores?: RevisorResumen[] | null;
  solicitante?: Solicitante;
  SOLICITUD_RIZOMA?: SolicitudRizoma | null;
  vigenciasSni?: IVigenciaDto[];
  reconsideracion?: Reconsideracion | null;
  datosGeneralesAcreditaciones?: IDatosGenerales | null;
  movimiento?: object;
  investigador?: Solicitante;
  operadorSelect?: string;
  extemporanea?: boolean;
  oficio?: string;
  estadoDocComprobante?: string;
  estadoDocInforme?: string;
  urlComprobante?: IFile;
  urlInforme?: IFile;
  contenidoBase64?: string;
  estadoFormalizacion?: string;
  ayudante?: object;
  reconocimiento?: string;
  urlConvenio?: string;
  isReconsideracion(): boolean;
  isEmerito(): boolean;
  esExtemporanea(): boolean;
  getInvestigador(): Solicitante;
  reconocimiento_reconsideracion?: string;
  reconocimiento_dictaminadora?: string;
  oficio_reconsideracion?: string;
  oficio_dictaminadora?: string;
  urlConvenio_reconsideracion?: string;
  urlConvenio_dictaminadora?: string;
  programa?: Programa;
  programasIntegrados?: IProgramaIntegrado[];
  cuota?: Cuota;
  planDeEstudios?: IPlanDeEstudios;
  areasConocimiento?: AreaConocimiento[];
  reestructuraciones?: IReestructuracion[];
  lies?: Array<LieSnp>;
  opcionesTerminales?: Array<OpcionTerminalSnp>;
  pronace?: PronaceSnp;
  temas?: Array<RegistroTemaSnp>;
  generaciones?: Array<GeneracionSnp>;
  datos_conciliados?: any;
  terminos_aceptados?: boolean;
  dependientes_modificados?: boolean;
  ajustes_solicitados?: boolean;
  calificacionPromedio?: number;
  beneficiario?: any;
  usuarioAsistente?: string | null;
  comprobantePdf?: ComprobantePdf;
  usuarios?: IUsuarioRol[];
  claveOficio?: string;
  claveReconocimiento?: string;
  cumpleAcreditacion?: boolean;
  cab?: string;
  anexo_uno?: string;
  carta_issste?: string;
  solicitudUri?: string;
  tipoMovimiento?: string;
  iteracion?: number;
  datosGenerales?: any;
  cuestionario?: any;
  variablesSociodemograficas?: any;
  cronogramaActividades?: ICronograma[];
  fechaInicioMovilidad?: string;
  fechaFinMovilidad?: string;
  inicioPeriodoMovilidad?: string;
  finPeriodoMovilidad?: string;
  duracionMovilidadMesesDias?: string;
  beca?: Beca;
  duracionMovilidadMeses?: number;
  cotutor?: ICotutor;
  perfil?: any;
  institucion?: any;
  instituciones?: Array<any>;
  valoracionIndividual?: IValoracionIndividual;
  comisionDictaminadora?: CuestionarioSnp;
  comisionReconsideracion?: CuestionarioSnp;
  resultadoAcreditacion?: ResultadoAcreditacion;
  resultadoReconsideracion?: ResultadoAcreditacion;
  documentoFormalizacion?: DocumentoFormalizacion;
  documentoFormalizacionReconsideracion?: DocumentoFormalizacion;
  solicitudReplica?: SolicitudReplica;
  apoyoSolicitado?: any;
  nombreProyecto?: string | null;
  objetivoEstancia?: string | null;
  resultadoEstancia?: string | null;
  transacciones?: Transaccion[];
  adeudos?: Movimiento[];
  tags?: string[] | null;
  isColaboracion?: boolean | null;
  convenioColaboracion?: number | null;
  createdDate?: Date;
  cuentaBancaria?: string;
  programaCondicionado?: boolean;
  validadorSelect?: string;
  coordinador?: Coordinador;
  declaraciones?: IDeclaraciones;
  fechaInicioTutoria?: string;
  fechaFinTutoria?: string;
  duracionTutoriadMeses?: number;
  firmaFormato1?: FirmaFormato1;
  programaTutoria?: string;
  fechaUltimoEvento?: string;
  becariosRetribucion?: Array<BecarioRetribucion>;
  actividadRetribucion?: ActividadRetribucion;
  poblacionRetribucion?: PoblacionRetribucion;
  resultadosRetribucion?: ResultadosRetribucion;
  indicadoresRetribucion?: IndicadoresRetribucion;
  vinculacionRetribucion?: VinculacionRetribucion;
  testimonioRetribucion?: TestimonioRetribucion;
}

export class Solicitud implements ISolicitud {
  constructor(
    public id?: string,
    public nombre?: string | null,
    public usuario?: string | null,
    public solucionId?: string | null,
    public estado?: EstadoSolicitud | null,
    public revisores?: RevisorResumen[] | null,
    public solicitante?: Solicitante,
    public SOLICITUD_RIZOMA?: any,
    public vigenciasSni?: IVigenciaDto[],
    public reconsideracion?: Reconsideracion,
    public movimiento?: any,
    public investigador?: Solicitante,
    public operadorSelect?: string,
    public programa?: Programa,
    public urlComprobante?: IFile,
    public urlInforme?: IFile,
    public estadoDocComprobante?: string,
    public estadoDocInforme?: string,
    public extemporanea?: boolean,
    public oficio?: string,
    public reconocimiento?: string,
    public urlConvenio?: string,
    public contenidoBase64?: string,
    public estadoFormalizacion?: string,
    public ayudante?: any,
    public reconocimiento_reconsideracion?: string,
    public reconocimiento_dictaminadora?: string,
    public oficio_reconsideracion?: string,
    public oficio_dictaminadora?: string,
    public urlConvenio_reconsideracion?: string,
    public urlConvenio_dictaminadora?: string,
    public cuota?: Cuota,
    public planDeEstudios?: IPlanDeEstudios,
    public programasIntegrados?: IProgramaIntegrado[],
    public areasConocimiento?: AreaConocimiento[],
    public lies?: Array<LieSnp>,
    public opcionesTerminales?: Array<OpcionTerminalSnp>,
    public pronace?: PronaceSnp,
    public temas?: Array<RegistroTemaSnp>,
    public generaciones?: Array<GeneracionSnp>,
    public integrantesClonados?: number,
    public reestructuraciones?: IReestructuracion[],
    public datos_conciliados?: any,
    public terminos_aceptados?: boolean,
    public dependientes_modificados?: boolean,
    public ajustes_solicitados?: boolean,
    public calificacionPromedio?: number,
    public beneficiario?: any,
    public usuarioAsistente?: string | null,
    public comprobantePdf?: ComprobantePdf,
    public usuarios?: IUsuarioRol[],
    public acusePdf?: AcusePdf,
    public comprobanteAnualPdf?: ComprobantePdf,
    public cumpleAcreditacion?: boolean,
    public cab?: string,
    public anexo_uno?: string,
    public carta_issste?: string,
    public solicitudUri?: string,
    public tipoMovimiento?: string,
    public resultadoClasificador?: IResultadoClasificador,
    public datosGenerales?: any,
    public cuestionario?: any,
    public variablesSociodemograficas?: any,
    public cronogramaActividades?: ICronograma[],
    public fechaInicioMovilidad?: string,
    public fechaFinMovilidad?: string,
    public inicioPeriodoMovilidad?: string,
    public finPeriodoMovilidad?: string,
    public duracionMovilidadMesesDias?: string,
    public beca?: Beca,
    public duracionMovilidadMeses?: number,
    public cotutor?: ICotutor,
    public perfil?: any,
    public institucion?: any,
    public instituciones?: Array<any>,
    public valoracionIndividual?: IValoracionIndividual,
    public datosHijos?: IHijos[],
    public nombreConvocatoria?: string,
    public comisionDictaminadora?: CuestionarioSnp,
    public comisionReconsideracion?: CuestionarioSnp,
    public resultadoAcreditacion?: ResultadoAcreditacion,
    public resultadoReconsideracion?: ResultadoAcreditacion,
    public documentoFormalizacion?: DocumentoFormalizacion,
    public documentoFormalizacionReconsideracion?: DocumentoFormalizacion,
    public solicitudReplica?: SolicitudReplica,
    public apoyoSolicitado?: any,
    public nombreProyecto?: string | null,
    public objetivoEstancia?: string | null,
    public resultadoEstancia?: string | null,
    public transacciones?: ITransaccion[],
    public adeudos?: IMovimiento[],
    public tags?: string[] | null,
    public isColaboracion?: boolean | null,
    public convenioColaboracion?: number | null,
    public createdDate?: Date,
    public cuentaBancaria?: string,
    public vistaPreviaActiva?: boolean,
    public programaCondicionado?: boolean,
    public validadorSelect?: string,
    public acreditacionActividades?: SolicitudAcreditacionLigera,
    public coordinador?: Coordinador,
    public declaraciones?: Declaraciones,
    public fechaInicioTutoria?: string,
    public fechaFinTutoria?: string,
    public duracionTutoriadMeses?: number,
    public firmaFormato1?: FirmaFormato1,
    public acreditacionActividadesDiaspora?: SolicitudAcreditacionLigera,
    public programaTutoria?: string,
    public fechaUltimoEvento?: string,
    public becariosRetribucion?: Array<BecarioRetribucion>,
    public actividadRetribucion?: ActividadRetribucion,
    public poblacionRetribucion?: PoblacionRetribucion,
    public resultadosRetribucion?: ResultadosRetribucion,
    public indicadoresRetribucion?: IndicadoresRetribucion,
    public vinculacionRetribucion?: VinculacionRetribucion,
    public testimonioRetribucion?: TestimonioRetribucion
  ) {
    this.revisores = this.revisores ? this.revisores : [];
  }

  /**
   * Crea una instancia de Solicitud a partir de un objeto plano.
   * @param data Objeto que contiene los datos de la solicitud.
   */
  static fromObject(data: ISolicitud): Solicitud {
    const transformations: any = {
      vigenciasSni: (vigenciasSni: IVigenciaDto[]) => (vigenciasSni !== undefined ? vigenciasSni.map(VigenciaDto.fromObject) : []),
      pronace: (pronace: PronaceSnp) => PronaceSnp.fromObject(pronace),
      cuota: (cuota: Cuota) => Cuota.fromObject(cuota),
      becariosRetribucion: (becariosRetribucion: Array<BecarioRetribucion>) =>
        becariosRetribucion != undefined ? becariosRetribucion.map(BecarioRetribucion.fromObject) : [],
      actividadRetribucion: (actividadRetribucion: ActividadRetribucion) => ActividadRetribucion.fromObject(actividadRetribucion),
      poblacionRetribucion: (poblacionRetribucion: PoblacionRetribucion) => PoblacionRetribucion.fromObject(poblacionRetribucion),
      resultadosRetribucion: (resultadosRetribucion: ResultadosRetribucion) => ResultadosRetribucion.fromObject(resultadosRetribucion),
      indicadoresRetribucion: (indicadoresRetribucion: IndicadoresRetribucion) => IndicadoresRetribucion.fromObject(indicadoresRetribucion),
      vinculacionRetribucion: (vinculacionRetribucion: VinculacionRetribucion) => VinculacionRetribucion.fromObject(vinculacionRetribucion),
      testimonioRetribucion: (testimonioRetribucion: TestimonioRetribucion) => TestimonioRetribucion.fromObject(testimonioRetribucion),
    };

    const solicitud: any = new Solicitud();

    for (const [key, value] of Object.entries(data)) {
      const transform = transformations[key];
      solicitud[key] = transform ? transform(value) : value;
    }

    solicitud.nombreCompleto = personaUtils.fullName(solicitud.solicitante);

    return solicitud as Solicitud;
  }

  /**
   * Indica si está en reconsideración.
   */
  public isReconsideracion(): boolean {
    return !!this.reconsideracion?.uri;
  }

  /**
   * Indica si la solicitud es de tipo Emeritos.
   */
  public isEmerito(): boolean {
    return this.SOLICITUD_RIZOMA?.solucionSolicitud?.tipoSolucion === TipoSolucion.EMERITOS;
  }

  /**
   * Indica si la solicitud contiene la propiedad extemporánea.
   */
  public esExtemporanea(): boolean {
    return this.extemporanea === true;
  }

  /**
   * Se valida si el campo investigador tiene datos en caso de que no
   * se obtendra del campo solicitante.
   */
  public getInvestigador(): Solicitante {
    return this.investigador ?? this.solicitante ?? {};
  }
}

export interface Reconsideracion {
  uri?: string;
  nombre?: string;
  motivo?: string;
  nuevaUriPu?: string;
  fechaEnvio?: Date;
  urlRepositorio?: string;
}

export interface IPlanDeEstudios {
  periodoLectivo?: string;
  periodicidad?: string;
  actividades?: string[];
  modificacion?: string;
  fechaActualizacion?: Date;
  objetivo?: string;
  congruencia?: string;
  perfilIngreso?: string;
  perfilEgreso?: string;
  duracionOficial?: number;
  totalPeriodosLectivos?: number;
  porcentajePracticas?: number;
}

export class PlanDeEstudios implements IPlanDeEstudios {
  constructor(
    public periodoLectivo?: string,
    public periodicidad?: string,
    public actividades?: string[],
    public modificacion?: string,
    public fechaActualizacion?: Date,
    public objetivo?: string,
    public congruencia?: string,
    public perfilIngreso?: string,
    public perfilEgreso?: string,
    public duracionOficial?: number,
    public totalPeriodosLectivos?: number,
    public porcentajePracticas?: number
  ) {}

  static fromObject(object: IPlanDeEstudios): PlanDeEstudios {
    return Object.assign(new PlanDeEstudios(), object);
  }
}

export interface ICuota {
  cobra?: boolean;
  esVoluntario?: boolean;
  frecuenciaColegiatura?: { id?: number; nombre?: string };
  frecuenciaInscripcion?: { id?: number; nombre?: string };
  frecuenciaOtraCuota?: { id?: number; nombre?: string };
  montoColegiatura?: number;
  montoInscripcion?: number;
  montoOtra?: number;
  tipoCuota?: string;
}

export class Cuota implements ICuota {
  constructor(
    public cobra?: boolean,
    public esVoluntario?: boolean,
    public frecuenciaColegiatura?: { id?: number; nombre?: string },
    public frecuenciaInscripcion?: { id?: number; nombre?: string },
    public frecuenciaOtraCuota?: { id?: number; nombre?: string },
    public montoColegiatura?: number,
    public montoInscripcion?: number,
    public montoOtra?: number,
    public tipoCuota?: string
  ) {}

  static fromObject(object: ICuota): Cuota {
    return Object.assign(new Cuota(), object);
  }
}

export interface IReestructuracion {
  fechaReestructuracion?: string | Date;
  fechaInicioOperacion?: string | Date;
  antecedentesPrograma?: string;
  justificacionReestructuracion?: string;
  razonRecienteCreacion?: string;
}

export class Reestructuracion implements IReestructuracion {
  constructor(
    public fechaReestructuracion?: string | Date,
    public fechaInicioOperacion?: string | Date,
    public antecedentesPrograma?: string,
    public justificacionReestructuracion?: string,
    public razonRecienteCreacion?: string
  ) {}
}

export interface ComprobantePdf {
  uri?: string;
  nombre?: string;
  fechaFirma?: string;
  firma?: string;
}
export interface AcusePdf {
  uri?: string;
  nombre?: string;
  fechaFirma?: string;
  firma?: string;
}

// Interfaces nuevas para clasificador
export interface IRubroClasificador {
  clave?: string;
  descripcion?: string;
  puntajeAObtener?: number;
  puntajeMinimo?: number;
  puntajeObtenido?: number;
}

export interface IResultadoClasificador {
  rubrosClasificador?: IRubroClasificador[];
  puntajeTotal?: number;
  puntajeTotalMinimo?: number;
}

export interface DocumentoFormalizacion {
  cvu?: string;
  fechaFirma?: string;
  nombreCompleto?: string;
  selloDigital?: string;
  url?: string;
  qrImagen?: string;
}

export interface ITransaccion {
  id?: string;
  fecha?: string;
  tipoTransaccion?: string;
  lineaCaptura?: string;
  estatus?: string;
  monto?: string;
  usuarioAlta?: string;
  fechaAlta?: Date;
  adeudoId?: string;
  documento?: File;
  fechaExpLineaCap?: string;
}

export class Transaccion implements ITransaccion {
  constructor(
    public id?: string,
    public fecha?: string,
    public tipoTransaccion?: string,
    public estatus?: string,
    public monto?: string,
    public lineaCaptura?: string,
    public usuarioAlta?: string,
    public fechaAlta?: Date,
    public adeudoId?: string,
    public documento?: File,
    public fechaExpLineaCap?: string
  ) {}
}

export interface ISolicitudAcreditacionLigera {
  id?: string;
  solucionId?: string;
  estado?: string;
  cvu?: string;
  situacion?: string;
  fechaInicioSituacion?: string;
  fechaFinSituacion?: string;
  fechaRegistro?: string;
  institucion?: string;
  dependencia?: string;
  subDependencia?: string;
  departamento?: string;
  tipoNivel?: string;
  idTipoNivel?: number;
  estadoInstitucion?: string;
  idEstadoInstitucion?: number;
  urlComprobante?: string;
  nombreComprobante?: string;
  fechaFormalizacionComprobante?: string;
  institucionExtranjera?: string;
  paisInstitucionExtranjera?: string;
}

export class SolicitudAcreditacionLigera implements ISolicitudAcreditacionLigera {
  constructor(
    public id?: string,
    public solucionId?: string,
    public estado?: string,
    public cvu?: string,
    public situacion?: string,
    public fechaInicioSituacion?: string,
    public fechaFinSituacion?: string,
    public fechaRegistro?: string,
    public institucion?: string,
    public dependencia?: string,
    public subDependencia?: string,
    public departamento?: string,
    public tipoNivel?: string,
    public idTipoNivel?: number,
    public estadoInstitucion?: string,
    public idEstadoInstitucion?: number,
    public urlComprobante?: string,
    public nombreComprobante?: string,
    public fechaFormalizacionComprobante?: string
  ) {}
}
